document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a page with bundle products
  if (!document.querySelector('.bundle-products-container')) return;
  
  const bundleContainer = document.getElementById('dynamic-bundle-products');
  const bundleProducts = [];

  function getAbbreviation(variant, variantType) {
  if (variantType.toLowerCase().includes('size')) {
    return variant
      .replace('Extra Small', 'XS')
      .replace('Small', 'S')
      .replace('Medium', 'M')
      .replace('Large', 'L')
      .replace('Extra Large', 'XL');
  }
  return variant;
}
  
  // Get bundle products from form structure (for products with variants)
  function getBundleProductsFromForm() {
    const products = [];
    const processedProducts = new Set();
    
    // Look for radio inputs with product names
    const radioInputs = document.querySelectorAll('input[type="radio"]');
    
    radioInputs.forEach(input => {
      const name = input.name || '';
      
      if (name.includes('(') && name.includes(')')) {
        const parts = name.split('(');
        const productName = parts[0].trim();
        const variantType = parts[1].replace(')', '').trim();
        
        if (!processedProducts.has(productName)) {
          processedProducts.add(productName);
          
          // Find all variants for this product
          const variants = [];
          document.querySelectorAll(`input[name="${name}"]`).forEach(radio => {
            if (radio.value && !variants.includes(radio.value)) {
              variants.push(radio.value);
            }
          });
          
          products.push({
            name: productName,
            variantType: variantType,
            variants: variants,
            hasVariants: variants.length > 1,
            source: 'form'
          });
        }
      }
    });
    
    return products;
  }
  
  // Get additional products from metafields
  async function getAdditionalProductsFromMetafields() {
    const additionalProducts = [];
    
    // Check for our custom script tag with bundle metafield data
    const bundleScript = document.getElementById('bundle-metafield-data');
    
    if (bundleScript) {
      try {
        const bundleData = JSON.parse(bundleScript.textContent);
        
        if (bundleData.additional_products && bundleData.additional_products.length > 0) {
          for (const productData of bundleData.additional_products) {
            additionalProducts.push({
              name: productData.title,
              variantType: 'Product',
              variants: ['One Size'],
              hasVariants: false,
              source: 'metafield',
              productData: productData,
              imageUrl: productData.featured_image || (productData.images && productData.images[0])
            });
          }
        }
      } catch (error) {
        console.error('Error parsing bundle metafield script:', error);
      }
    }
    
    return additionalProducts;
  }
  
  // Initialize the bundle display
  async function initializeBundleDisplay() {
    // Get products with variants from the form
    const formProducts = getBundleProductsFromForm();
    
    // Get additional single-variant products from metafields
    const additionalProducts = await getAdditionalProductsFromMetafields();
    
    // Start with metafield products in their specified order
    const allMetafieldProducts = [...additionalProducts];
    
    // Enhance metafield products with form variant data if they exist
    formProducts.forEach(formProduct => {
      const matchingMetaIndex = allMetafieldProducts.findIndex(metaProduct => 
        metaProduct.name.toLowerCase().includes(formProduct.name.toLowerCase()) ||
        formProduct.name.toLowerCase().includes(metaProduct.name.toLowerCase())
      );
      
      if (matchingMetaIndex !== -1) {
        // Replace the metafield product with enhanced form product data
        allMetafieldProducts[matchingMetaIndex] = {
          ...allMetafieldProducts[matchingMetaIndex],
          variants: formProduct.variants,
          hasVariants: formProduct.hasVariants,
          variantType: formProduct.variantType,
          source: 'form_enhanced'
        };
      }
    });
    
    // Add any form products that weren't found in metafields
    formProducts.forEach(formProduct => {
      const existsInMetafield = allMetafieldProducts.some(metaProduct => 
        metaProduct.name.toLowerCase().includes(formProduct.name.toLowerCase()) ||
        formProduct.name.toLowerCase().includes(metaProduct.name.toLowerCase())
      );
      
      if (!existsInMetafield) {
        allMetafieldProducts.push(formProduct);
      }
    });
    
    // Use the metafield-ordered products
    bundleProducts.push(...allMetafieldProducts);
    
    if (bundleProducts.length === 0) {
      bundleContainer.innerHTML = '<p>No bundle products configured.</p>';
      return;
    }
    
    // Generate HTML for each product
    bundleProducts.forEach((product, index) => {
      const productElement = createProductElement(product, index);
      bundleContainer.appendChild(productElement);
    });
    
    // Set up variant selection logic
    setupVariantSelection();
    setupMobileDropdowns();
  }
  
  function createProductElement(product, index) {
    const productDiv = document.createElement('div');
    productDiv.className = 'bundle-product-item';
    
    // Determine the best image URL to use
    let primaryImageUrl = '';
    
    if (product.imageUrl) {
      primaryImageUrl = product.imageUrl;
    } else {
      // Fallback to handle-based image URL
      const imageHandle = product.name.toLowerCase()
        .replace(/[™®]/g, '')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-]/g, '');
      
      primaryImageUrl = `/cdn/shop/products/${imageHandle}.jpg`;
    }
    
    // Get product URL from metafield data if available
let productUrl = '#';
if (product.productData && product.productData.handle) {
  productUrl = `/products/${product.productData.handle}`;
}

productDiv.innerHTML = `
  <div class="bundle-product-image">
    ${productUrl !== '#' ? 
      `<a href="${productUrl}" style="display: block;">
        <img src="${primaryImageUrl}" 
             alt="${product.name}"
             onerror="this.style.display='none';"
             onload="this.style.opacity=1"
             style="cursor: pointer;">
      </a>` :
      `<img src="${primaryImageUrl}" 
           alt="${product.name}"
           onerror="this.style.display='none';"
           onload="this.style.opacity=1">`
    }
  </div>
      <div class="bundle-product-info">
        <h4 class="bundle-product-name">${product.name}</h4>
      </div>
      <div class="bundle-product-variants">
        ${product.hasVariants ? createVariantSelector(product, index) : createSingleVariant(product.variants[0])}
      </div>
    `;
    
    return productDiv;
  }


  
  function createVariantSelector(product, index) {
    // Create both desktop buttons and mobile dropdown
    
    const buttonVariants = product.variants.map((variant, i) => {
  let displayName = variant;
  
  // Smart abbreviation for buttons
  if (product.variantType.toLowerCase().includes('size')) {
    displayName = variant
      .replace('Extra Small', 'XS')
      .replace('Small', 'S')
      .replace('Medium', 'M')
      .replace('Large', 'L')
      .replace('Extra Large', 'XL');
  }
  
  // Check if variant is sold out by looking at the original radio buttons
  const originalRadio = document.querySelector(`input[type="radio"][name*="${product.name}"][value="${variant}"]`);
  const isSoldOut = originalRadio ? originalRadio.disabled : false;
  
  console.log(`Variant ${variant}: soldOut = ${isSoldOut}`); // Debug log
  
  return `<button class="variant-option ${i === 0 && !isSoldOut ? 'active' : ''} ${isSoldOut ? 'sold-out' : ''}" 
                  data-value="${variant}" 
                  data-product="${index}"
                  title="${variant}"
                  ${isSoldOut ? 'disabled' : ''}>${displayName}</button>`;
}).join('');
    
    // Create dropdown options
const dropdownOptions = product.variants.map((variant, i) => {
  let displayName = variant;
  
  // Smart abbreviation for dropdown options
  if (product.variantType.toLowerCase().includes('size')) {
    displayName = variant
      .replace('Extra Small', 'XS')
      .replace('Small', 'S')
      .replace('Medium', 'M')
      .replace('Large', 'L')
      .replace('Extra Large', 'XL');
  }
  
  // Check if variant is sold out (same logic as desktop)
  const originalRadio = document.querySelector(`input[type="radio"][name*="${product.name}"][value="${variant}"]`);
  const isSoldOut = originalRadio ? originalRadio.disabled : false;
  
  return `<div class="dropdown-option ${i === 0 && !isSoldOut ? 'selected' : ''} ${isSoldOut ? 'sold-out' : ''}" 
               data-value="${variant}" 
               ${isSoldOut ? 'data-disabled="true"' : ''}>${displayName}</div>`;
}).join('');
    
    return `
      <div class="variant-selector" data-product="${index}" data-variant-type="${product.variantType}">
        <!-- Desktop: Button selector -->
        <div class="variant-buttons desktop-only">
          ${buttonVariants}
        </div>
        
        <!-- Mobile: Dropdown selector -->
        <div class="variant-dropdown mobile-only">
          <div class="dropdown-trigger" data-product="${index}">
            <span class="selected-value">${getAbbreviation(product.variants[0], product.variantType)}</span>
            <svg class="dropdown-arrow" width="14" height="9" viewBox="0 0 14 9" fill="none">
  <path d="M13 1.54004L7 7.54004L1 1.54004" stroke="#313f77" stroke-width="2"></path>
</svg>
          </div>
          <div class="dropdown-options" data-product="${index}">
            ${dropdownOptions}
          </div>
        </div>
      </div>
    `;
  }
  
  function createSingleVariant(variantName) {
    let displayName = variantName === 'Default Title' || !variantName ? 'One Size' : variantName;
    
    return `
      <div class="single-variant-container">
        <div class="single-variant">${displayName}</div>
      </div>
    `;
  }
  
  function setupVariantSelection() {
    // Desktop button clicks
    const variantButtons = document.querySelectorAll('.variant-option');
    variantButtons.forEach(button => {
      button.addEventListener('click', function() {
        const selector = this.closest('.variant-selector');
        selector.querySelectorAll('.variant-option').forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        
        // Update mobile dropdown
        const mobileDropdown = selector.querySelector('.selected-value');
        if (mobileDropdown) {
          mobileDropdown.textContent = this.dataset.value;
        }
        
        // Update mobile dropdown selected state
        const dropdownOptions = selector.querySelectorAll('.dropdown-option');
        dropdownOptions.forEach(opt => opt.classList.remove('selected'));
        const matchingOption = selector.querySelector(`[data-value="${this.dataset.value}"]`);
        if (matchingOption && matchingOption.classList.contains('dropdown-option')) {
          matchingOption.classList.add('selected');
        }
        
        updateBundleVariant();
      });
    });
  }
  
  function setupMobileDropdowns() {
    // Mobile dropdown triggers
    const dropdownTriggers = document.querySelectorAll('.dropdown-trigger');
    dropdownTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const productIndex = this.dataset.product;
        const dropdown = document.querySelector(`.dropdown-options[data-product="${productIndex}"]`);
        
        // Close all other dropdowns
        document.querySelectorAll('.dropdown-options').forEach(d => {
          if (d !== dropdown) d.classList.remove('active');
        });
        
        // Toggle current dropdown
        dropdown.classList.toggle('active');
      });
    });
    
    // Mobile dropdown option selection
    const dropdownOptions = document.querySelectorAll('.dropdown-option');
    dropdownOptions.forEach(option => {
      option.addEventListener('click', function() {
  // Don't allow selection of sold out variants
  if (this.dataset.disabled === 'true') {
    return;
  }
  
  const value = this.dataset.value;
        const productIndex = this.closest('.dropdown-options').dataset.product;
        const selector = document.querySelector(`.variant-selector[data-product="${productIndex}"]`);
        
        // Update selected state
        this.closest('.dropdown-options').querySelectorAll('.dropdown-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        this.classList.add('selected');
        
        // Update trigger text
        const trigger = selector.querySelector('.selected-value');
if (selector.dataset.variantType && selector.dataset.variantType.toLowerCase().includes('size')) {
  const abbreviatedValue = value
    .replace('Extra Small', 'XS')
    .replace('Small', 'S')
    .replace('Medium', 'M')
    .replace('Large', 'L')
    .replace('Extra Large', 'XL');
  trigger.textContent = abbreviatedValue;
} else {
  trigger.textContent = value;
}
        
        // Update desktop buttons
        const button = selector.querySelector(`[data-value="${value}"]`);
        if (button && button.classList.contains('variant-option')) {
          selector.querySelectorAll('.variant-option').forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');
        }
        
        // Close dropdown
        this.closest('.dropdown-options').classList.remove('active');
        
        updateBundleVariant();
      });
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.variant-dropdown')) {
        document.querySelectorAll('.dropdown-options').forEach(dropdown => {
          dropdown.classList.remove('active');
        });
      }
    });
  }
  
  function updateBundleVariant() {
    // Update the original bundle form radio buttons
    const productSelectors = document.querySelectorAll('.variant-selector[data-product]');
    
    productSelectors.forEach((selector, productIndex) => {
      const activeButton = selector.querySelector('.variant-option.active');
      if (activeButton) {
        const selectedValue = activeButton.dataset.value;
        
        // Find the corresponding original radio button and check it
        const originalRadios = document.querySelectorAll(`input[type="radio"][name*="${bundleProducts[productIndex].name}"]`);
        
        originalRadios.forEach(radio => {
          if (radio.value === selectedValue) {
            radio.checked = true;
            // Trigger change event to update the bundle
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            radio.checked = false;
          }
        });
      }
    });
  }
  
  // Start the initialization
  initializeBundleDisplay();
});